// extracted by mini-css-extract-plugin
export default {"container":"Do-z","ratingLayout":"Eo-z","ratingLabel":"Fo-z","nonInteractiveRatingLabel":"Go-z"};